"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSdkKeyFromCookie = getSdkKeyFromCookie;
exports.removeSdkKeyCookie = removeSdkKeyCookie;
const constants_1 = require("@aurora/shared-types/developer/constants");
const universal_cookie_1 = __importDefault(require("universal-cookie"));
function getCookies(cookie) {
    return new universal_cookie_1.default(cookie);
}
/**
 * Gets the sdk key from the `auroraSdkKey` cookie
 *
 * @param cookie the cookie string only needed for reading the cookie during the server side render
 */
function getSdkKeyFromCookie(cookie) {
    return getCookies(cookie).get(constants_1.SDK_KEY_COOKIE_NAME);
}
/**
 * Removes the SDK key cookie.
 */
function removeSdkKeyCookie() {
    getCookies().remove(constants_1.SDK_KEY_COOKIE_NAME, { path: '/' });
}
//# sourceMappingURL=SdkCookieHelper.js.map